<template>
    <v-pagination
        :length="length"
        :disabled="length === 1"
        :prev-icon="mdiChevronLeft"
        :next-icon="mdiChevronRight"
        v-model="page"
        :total-visible="totalVisible"
    />
</template>
<script lang="ts">
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js';
import { Vue } from 'vue-property-decorator';

export default Vue.extend({
    name: 'Paginator',
    props: {
        value: {
            type: Number,
            default: 0,
        },
        count: {
            type: Number,
            required: true,
        },
        total: {
            type: Number,
            required: true,
        },
        totalVisible: {
            type: Number,
            required: true,
        },
    },
    computed: {
        length(): number {
            return this.count !== 0 ? Math.ceil(this.total / this.count) : 0;
        },
        page: {
            get(): number {
                return Math.floor(this.value / this.count) + 1;
            },
            set(page: number): void {
                this.$emit('input', (page - 1) * this.count);
            },
        },
    },
    data() {
        return {
            mdiChevronLeft,
            mdiChevronRight,
        };
    },
});
</script>
